import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from "../Pages/Home/Home";
import MediaGallery from "../Pages/MediaGallery/MediaGallery";
import Contacts from "../Pages/Contacts/Contacts";
import TermsConditions from '../Pages/TermsConditions';
import Privacy from '../Pages/Privacy';
import SingleArticle from '../Pages/SingleArticle';

const AppRoute = () => {
    return (
        <Routes>
            <Route path='*' element={<Home />} />
            <Route path='/' element={<Home />} />
            <Route path='/gallery' element={<MediaGallery />} />
            <Route path='/contacts' element={<Contacts />} />
            <Route path='/termsConditions' element={<TermsConditions />} />
            <Route path='/privacy' element={<Privacy />} />
            <Route path='/article/:channelGuid/:assetId' element={<SingleArticle />} />
        </Routes>
    )
}

export default AppRoute